import React from 'react';
import { getCertifiedCourses } from '../data/learningCycleData';

const CertifiedCoursesPage = ({ language = 'traditional', onBack, onStartTraining }) => {
  const coursesData = getCertifiedCourses();

  const getText = (textObj) => {
    return textObj[language] || textObj.traditional;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 text-white">
      {/* Header */}
      <div className="px-6 py-6">
        <div className="flex items-center justify-between mb-6">
          <button onClick={onBack} className="text-white">
            ←
          </button>
          <h1 className="text-xl font-bold">
            {getText(coursesData.title)}
          </h1>
          <div className="w-8"></div> {/* Spacer for centering */}
        </div>

        {/* Main Title and Description */}
        <div className="mb-6">
          <h2 className="text-2xl font-bold mb-3">
            {getText(coursesData.title)}
          </h2>
          <p className="text-gray-300 text-sm leading-relaxed">
            {getText(coursesData.description)}
          </p>
        </div>

        {/* Featured Course Card */}
        <div className="bg-gradient-to-r from-blue-500 to-purple-600 rounded-xl p-6 mb-6">
          <h3 className="text-2xl font-bold text-center">
            {getText(coursesData.featuredCourse.title)}
          </h3>
        </div>

        <p className="text-gray-300 text-sm mb-6">
          {getText(coursesData.featuredCourse.description)}
        </p>

        {/* Course Overview */}
        <div className="mb-8">
          <h3 className="text-lg font-bold mb-4">
            {getText(coursesData.courseOverview.title)}
          </h3>
          
          <div className="space-y-3">
            {coursesData.courseOverview.units.map((unit) => (
              <div key={unit.id} className="bg-gray-800/30 border border-gray-600 rounded-xl p-4">
                <div className="flex items-center space-x-4">
                  <div className="text-2xl flex-shrink-0">
                    {unit.icon}
                  </div>
                  <div className="flex-1">
                    <h4 className="font-semibold text-white">
                      {getText({ traditional: `UNIT ${unit.number}`, simplified: `UNIT ${unit.number}`, english: `UNIT ${unit.number}` })}: {getText(unit.title)}
                    </h4>
                    <p className="text-gray-400 text-sm">
                      {unit.lessons} {getText({ traditional: '課程', simplified: '课程', english: 'Lessons' })}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Navigation and Action Buttons */}
        <div className="relative">
          {/* Navigation Arrows */}
          <div className="flex justify-between items-center mb-4">
            <button className="w-12 h-12 bg-gray-800 rounded-full flex items-center justify-center">
              <span className="text-white">←</span>
            </button>
            <button className="w-12 h-12 bg-gray-800 rounded-full flex items-center justify-center">
              <span className="text-white">→</span>
            </button>
          </div>

          {/* Start Training Button */}
          <button
            onClick={onStartTraining}
            className="w-full bg-gradient-to-r from-red-500 to-pink-500 hover:from-red-600 hover:to-pink-600 text-white font-semibold py-4 px-6 rounded-lg transition-colors"
          >
            {getText({ traditional: 'Start training!', simplified: 'Start training!', english: 'Start training!' })}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CertifiedCoursesPage;
